import { render, staticRenderFns } from "./GestioneAttivitaTasksEditComponent.vue?vue&type=template&id=a6619454"
import script from "./GestioneAttivitaTasksEditComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaTasksEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports